import React from "react";
import { FaRupeeSign, FaChartLine, FaBriefcase, FaFileInvoiceDollar, FaCar, FaMotorcycle } from "react-icons/fa";

interface ServicesProps {
  sectionRef: (el: HTMLElement | null) => void;
}

const Services: React.FC<ServicesProps> = ({ sectionRef }) => {
  return (
    <section id="services" ref={sectionRef} className="w-full py-24 md:py-32 bg-transparent text-text-primary relative">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-8">
          <div className="space-y-4">
            <div className="text-primary font-bold text-sm uppercase tracking-wider bg-primary/10 inline-block px-4 py-1.5 rounded-full">Our Core Offerings</div>
            <h2 className="text-4xl md:text-5xl font-extrabold leading-tight tracking-tight text-text-primary">
              Comprehensive <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary">Loan Services</span>
            </h2>
          </div>
          <div className="text-text-secondary font-medium text-lg max-w-[400px]">
            Tailored loan products designed to fuel growth, empower individuals, and support business excellence.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {[
            {
              title: "Short Term Personal Loan",
              icon: <FaRupeeSign />,
              desc: "Quick, hassle-free personal loans to meet your immediate financial requirements without long-term commitments."
            },
            {
              title: "Credit Builder Loan",
              icon: <FaChartLine />,
              desc: "Specially designed loans to help you establish, repair, or significantly improve your credit score securely."
            },
            {
              title: "MSME Loan",
              icon: <FaBriefcase />,
              desc: "Empowering small and medium enterprises with the working capital needed to expand operations and thrive."
            },
            {
              title: "GST Loan",
              icon: <FaFileInvoiceDollar />,
              desc: "Leverage your GST returns to secure fast, collateral-free business loans for uninterrupted cash flow."
            },
            {
              title: "Car Loan",
              icon: <FaCar />,
              desc: "Drive home your dream car with our highly competitive interest rates and flexible repayment tenures."
            },
            {
              title: "Bike Loan",
              icon: <FaMotorcycle />,
              desc: "Get on the road faster with our quick-approval two-wheeler loans, offering excellent financing up to 100%."
            }
          ].map((service, i) => (
             <div key={i} className="bg-white p-10 rounded-[2rem] border border-gray-100 shadow-lg hover:shadow-xl hover:-translate-y-2 transition-all duration-300 group">
              <div className="text-5xl text-primary mb-8 group-hover:scale-110 group-hover:text-secondary transition-transform origin-left">{service.icon}</div>
              <h3 className="text-2xl font-bold mb-4 text-text-primary">{service.title}</h3>
              <div className="w-12 h-1 bg-primary/20 mb-6 group-hover:bg-primary group-hover:w-20 transition-all rounded-full" />
              <p className="text-text-secondary leading-relaxed">{service.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
